(function bootstrapSuiQuizConfig(global) {
  const logConfig = global.SUI_QUIZ_LOG_CONFIG || {};
  const customerConfig = global.SUI_QUIZ_CUSTOMER_CONFIG || {};

  const resolveValue = (primary, fallback) => {
    const candidates = [primary, fallback].filter(Boolean);
    for (const value of candidates) {
      if (typeof value !== 'string') continue;
      const trimmed = value.trim();
      if (!trimmed) continue;
      if (trimmed.includes('PLACEHOLDER') || trimmed.startsWith('{{')) continue;
      return trimmed;
    }
    return null;
  };

  const logEndpoint = resolveValue(logConfig.endpoint, global.__QUIZ_LOG_ENDPOINT__);
  const logApiKey = resolveValue(logConfig.apiKey, global.__QUIZ_LOG_API_KEY__);
  const customerEndpoint = resolveValue(
    customerConfig.endpoint,
    global.__QUIZ_CUSTOMER_ENDPOINT__
  );

  if (logEndpoint) global.__QUIZ_LOG_ENDPOINT__ = logEndpoint;
  if (logApiKey) global.__QUIZ_LOG_API_KEY__ = logApiKey;
  if (customerEndpoint) global.__QUIZ_CUSTOMER_ENDPOINT__ = customerEndpoint;

  if (!global.__QUIZ_LOG_ENDPOINT__ && global.console && typeof global.console.warn === 'function') {
    global.console.warn('[SuiQuizConfig] Log endpoint eksik. window.SUI_QUIZ_LOG_CONFIG uzerinden atayin.');
  }
  if (!global.__QUIZ_CUSTOMER_ENDPOINT__ && global.console && typeof global.console.warn === 'function') {
    global.console.warn('[SuiQuizConfig] Customer endpoint eksik. window.SUI_QUIZ_CUSTOMER_CONFIG uzerinden atayin.');
  }
})(window);
